<template>
  <div class="row">
    <div v-if="editing" class="col col-12">
      <input type="text" v-model="newName">
      <button type="button" v-on:click="submit">登録</button>
      <button type="button" v-on:click="editing=false">キャンセル</button>
    </div>
    <div v-else class="col col-12">
      <h1 v-bind:style='{ "display": "inline" }'>{{ name }}</h1>
      <button v-on:click="editing=true">編集</button>
    </div>
  </div>
</template>

<script>
  //const axios = require('axios')

  export default {
    props: {
      name: String,
      id: String,
    },
    data: function() {
      return {
        newName: this.name,
        editing: false
      }
    },
    computed: {
      postFor: function () {
        return '/network/' + this.id;
      }
    },
    methods: {
      submit() {
        // let params = new URLSearchParams();
        // params.append('name', this.newName);
        // axios.post(this.postFor, params)
        //   .then(() => {
        //     location.reload(true);
        //   });
      },
    },
  }
</script>

<style scoped>
</style>